export type Tier = 'free' | 'paid' | 'unlimited';
export const ANON_MAX_PROMPTS = 1;
/** Balance the backend reports for unlimited (test/dev) accounts. */
export const UNLIMITED_CREDITS = 999_999_999;

export interface PromptContext {
  isAnonymous: boolean;
  anonPromptsUsed: number;
  tier: Tier;
  creditsRemaining: number;
}

export type PromptDenyReason = 'signup_required' | 'insufficient_credits';

export function canPrompt(ctx: PromptContext, devBypass = false): { allowed: boolean; reason?: PromptDenyReason } {
  if (devBypass) return { allowed: true };
  if (ctx.isAnonymous) {
    return ctx.anonPromptsUsed >= ANON_MAX_PROMPTS
      ? { allowed: false, reason: 'signup_required' }
      : { allowed: true };
  }
  if (ctx.creditsRemaining <= 0) return { allowed: false, reason: 'insufficient_credits' };
  return { allowed: true };
}

export function canEdit(tier: Tier, devBypass = false): boolean {
  // Unlimited is a superset of paid (test/owner accounts) — it must never gate BELOW paid.
  return devBypass || tier === 'paid' || tier === 'unlimited';
}
